import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import { Copy, Loader2 } from 'lucide-react';
import { DropdownMenuItem } from '@/components/ui/dropdown-menu';
import { useDuplicateVideo } from '@/hooks/use-duplicate-video';

export function DuplicateVideoMenuItem({ videoId, status, isShared = false }: {
  videoId: string;
  status?: string;
  isShared?: boolean;
}) {
  useLanguage();
  const { duplicateVideo, isPending } = useDuplicateVideo();
  if (isShared || !['active', 'processed'].includes(status)) return null;

  return (
    <DropdownMenuItem disabled={isPending} onClick={(event) => {
      event.stopPropagation();
      duplicateVideo(videoId);
    }}>
      {isPending ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <Copy className="mr-2 h-4 w-4" />}
      {isPending ? translateInterfaceText("Duplicando…") : translateInterfaceText("Duplicar")}
    </DropdownMenuItem>
  );
}
